import { render, staticRenderFns } from "./BlogList.vue?vue&type=template&id=8d83e056"
import script from "./BlogList.vue?vue&type=script&lang=js"
export * from "./BlogList.vue?vue&type=script&lang=js"
import style0 from "./BlogList.vue?vue&type=style&index=0&id=8d83e056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports